import React, { Component } from 'react'
import { connect } from 'react-redux'

import AssignItem from '../../../../NewWorkscreen/AssignItem'

class Popup extends Component {

  render () {
    let { item } = this.props
    if (this.props.StepAssignments.length === 0) return null
    let stepId = item.StepId
    // Find entry in step assignments
    let entry = null
    for (let i = 0; i < this.props.StepAssignments.length; i++) {
      if (this.props.StepAssignments[i].StepId === stepId) {
        this.props.StepAssignments[i].OrderAssignments.map((v) => {
          if (v.OrderId === item.Id) {
            entry = {...v}
          }
        })
        break
      }
    }
    return (
      <div className='poppedup padding circleInlinePopup'>
        <AssignItem item={entry} step={stepId} onAssignUsers={this.props.onAssignUsers} assignAriaPos={'bottom-left'} DontShowDeadline />
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    StepAssignments: state.assign.StepAssignments
  }
}

export default connect(mapStateToProps, {
})(Popup)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/Circle/popup.js